/**
 * @generated SignedSource<<a7051a45311592b7f7216ef5464f09bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectRow_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"DetectedPeopleSection_user" | "ProjectDetailsSection_user">;
  readonly " $fragmentType": "ProjectRow_user";
};
export type ProjectRow_user$key = {
  readonly " $data"?: ProjectRow_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRow_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectRow_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectDetailsSection_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DetectedPeopleSection_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "de4236a2d7cc4bd6e8cfd2a963cb7b56";

export default node;
